import { Col, Divider, Row, Typography } from "antd"
import PropTypes from "prop-types"
import React from "react"
import { useHistory } from "react-router-dom"
import styled from "styled-components"
import * as Yup from "yup"

import AppButton from "../../../_shared/components/AppButton"
import AppInput from "../../../_shared/components/FormItems/AppInput"
import useFormikForm from "../../../_shared/hooks/useFormikForm"
import { getIsEmailFree } from "../../../api"

// ----------------------------------------------------------------------------

function _SignupForm(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, onFinish, Error } = props
    const { Title } = Typography

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const validationSchema = new Yup.ObjectSchema({
        email: Yup.string()
            .email("l'indirizzo non è valido")
            .required("campo obbligatorio")
            .test({
                name: "No duplicate email",
                message: "Questo indirizzo è già in utilizzo",
                test: async (value) => {
                    const isEmail = await new Yup.StringSchema()
                        .email()
                        .validate(value)
                        .catch(() => false)

                    const ret = isEmail
                        ? await getIsEmailFree(value ?? "")
                        : false
                    return ret
                },
            }),
        password: Yup.string()
            .min(6, "almeno 6 caretteri")
            .required("campo obbligatorio"),
        businessName: Yup.string().required("campo obbligatorio"),
        vatNumber: Yup.string().required("campo obbligatorio"),
        registrationNumber: Yup.string().required("Campo obbligatorio"),
        phoneNumber: Yup.string().required("Campo obbligatorio"),
        confRegistration: Yup.string().required("Campo obbligatorio"),
    })

    const initialValues = {
        email: "",
        password: "",
        businessName: "",
        vatNumber: "",
        registrationNumber: "",
        phoneNumber: "",
        confRegistration: "",
    }

    const { getFieldProps, handleSubmit } = useFormikForm({
        initialValues,
        validationSchema,
        handleSubmit: onFinish,
    })

    const { push: navigate } = useHistory()

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function toLogin() {
        navigate("/")
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <form onSubmit={handleSubmit} className={className}>
            <div className="form-item">
                <Title level={3}>Registrati</Title>
                {Error}
                <Row gutter={12}>
                    <Col span={24}>
                        <AppInput label="E-mail" {...getFieldProps("email")} />
                    </Col>
                    <Col span={24}>
                        <AppInput
                            label="Password"
                            hiddenText
                            {...getFieldProps("password")}
                        />
                    </Col>
                    <Col span={24}>
                        <AppInput
                            label="Ragione sociale"
                            {...getFieldProps("businessName")}
                        />
                    </Col>
                    <Col span={24}>
                        <AppInput
                            label="Partita IVA"
                            {...getFieldProps("vatNumber")}
                        />
                    </Col>
                    <Divider />
                    <Typography.Paragraph>
                        La registrazione sul sito è permesso solo alle agenzie
                        che sono associate a Confedilizia. Per accertare che
                        questo sia il caso, è necessario fornire le seguenti
                        informazioni:
                        <ul>
                            <li>
                                Numero iscrizione al registro imprese e sigla
                                provincia
                            </li>
                            <li>Numero di telefono</li>
                            <li>Iscrizione Confedilizia Vicenza</li>
                        </ul>
                    </Typography.Paragraph>
                    <Col span={24}>
                        <AppInput
                            label="Numero iscrizione e sigla provincia"
                            {...getFieldProps("registrationNumber")}
                        />
                    </Col>
                    <Col span={24}>
                        <AppInput
                            label="Numero di telefono"
                            {...getFieldProps("phoneNumber")}
                        />
                    </Col>
                    <Col span={24}>
                        <AppInput
                            label="Iscrizione Confedilizia Vicenza"
                            {...getFieldProps("confRegistration")}
                        />
                    </Col>
                </Row>
            </div>
            <div className="form-item">
                <AppButton className="primary" type="submit">
                    Registrati
                </AppButton>
            </div>
            <small>
                <span>Hai già un account? </span>
                <span className="section-link" onClick={toLogin}>
                    {"Effettua l'accesso!"}
                </span>
            </small>
        </form>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_SignupForm.propTypes = {
    className: PropTypes.string.isRequired,
    onFinish: PropTypes.func,
    Error: PropTypes.any,
}

_SignupForm.defaultProps = {}

// ----------------------------------------------------------------------------

const SignupForm = styled(_SignupForm)`
    & {
        ul {
            li {
                font-weight: 700;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default SignupForm
